import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private translate: TranslateService = inject(TranslateService);

  unsubscribe: Subject<void> = new Subject<void>();
  OF_LABEL = 'of';

  constructor() {
    super();

    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });

    this.getAndInitTranslations();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getAndInitTranslations() {
    this.translate.get(['tableControls.paginator.itemsPerPage', 'tableControls.paginator.nextPage', 'tableControls.paginator.previousPage', 'tableControls.paginator.range']).subscribe((translation) => {
      this.itemsPerPageLabel = translation['tableControls.paginator.itemsPerPage'];
      this.nextPageLabel = translation['tableControls.paginator.nextPage'];
      this.previousPageLabel = translation['tableControls.paginator.previousPage'];
      this.OF_LABEL = translation['tableControls.paginator.range'];
      this.changes.next();
    });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.OF_LABEL} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.OF_LABEL} ${length}`;
  };
}
